import {NgOptimizedImage} from "@angular/common";
import {Component} from "@angular/core";
import {HeaderComponent} from "../../layout/header/header.component";
import {getOfferedServices} from "../../models/Services/OfferedService";

@Component({
  selector: "app-services",
  templateUrl: "./services.component.html",
  styleUrl: "./services.component.scss",
  imports: [
    HeaderComponent,
    NgOptimizedImage,
  ],
})
export class ServicesComponent {
  protected readonly services = getOfferedServices();
}
